"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _About = _interopRequireDefault(require("../../../../molecules/About"));

var _SiteMap = _interopRequireDefault(require("../../../../molecules/SiteMap"));

var _Subscribe = _interopRequireDefault(require("../../../../molecules/Subscribe"));

var _SocialMedia = _interopRequireDefault(require("../../../../molecules/SocialMedia"));

var CenterStackedVTwoBody = function CenterStackedVTwoBody(props) {
  var bodyColor = props.bodyColor,
      pages = props.pages,
      pagesClassName = props.pagesClassName,
      subscribe = props.subscribe,
      socialMedia = props.socialMedia,
      aboutUs = props.aboutUs;

  var onSubmitLoading = function onSubmitLoading() {
    return new Promise(function (res) {
      return setTimeout(function () {
        return res();
      }, 1000);
    });
  };

  var PagesColumn = function PagesColumn() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "footer-page-".concat(pages[0].title)
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      className: pagesClassName,
      computer: 3,
      tablet: 3,
      only: "computer tablet",
      textAlign: "left"
    }, /*#__PURE__*/_react["default"].createElement(_SiteMap["default"], {
      links: pages[0].pages
    })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      className: pagesClassName,
      mobile: 16,
      only: "mobile",
      textAlign: "center"
    }, /*#__PURE__*/_react["default"].createElement(_SiteMap["default"], {
      links: pages[0].pages
    })));
  };

  var SubscribeColumn = function SubscribeColumn() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 1,
      tablet: 1,
      mobile: 1
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 6,
      tablet: 6,
      mobile: 14,
      textAlign: "center"
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      style: {
        textTransform: 'none'
      }
    }, subscribe.header), /*#__PURE__*/_react["default"].createElement(_Subscribe["default"], {
      onSubmit: onSubmitLoading,
      placeholder: subscribe.placeholder,
      button: false
    }), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_SocialMedia["default"], {
      socialMediaValues: socialMedia,
      buttonType: "rect"
    })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 1,
      tablet: 1,
      only: "computer tablet"
    }));
  };

  var AboutUsColumn = function AboutUsColumn() {
    return aboutUs ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      mobile: 1,
      only: "mobile"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 3,
      tablet: 3,
      mobile: 12,
      textAlign: "center",
      className: "footer-aboutus-column"
    }, /*#__PURE__*/_react["default"].createElement(_About["default"], {
      header: aboutUs.header,
      withContainer: true,
      content: aboutUs.content,
      headerAs: "h4"
    })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      mobile: 1,
      only: "mobile"
    })) : null;
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: bodyColor,
      paddingTop: '2em',
      paddingBottom: '2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    centered: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    tablet: 1,
    only: "computer tablet"
  }), /*#__PURE__*/_react["default"].createElement(PagesColumn, null), /*#__PURE__*/_react["default"].createElement(SubscribeColumn, null), /*#__PURE__*/_react["default"].createElement(AboutUsColumn, null), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    tablet: 1,
    only: "computer tablet"
  })));
};

CenterStackedVTwoBody.propTypes = {
  bodyColor: _propTypes["default"].string.isRequired,
  pagesClassName: _propTypes["default"].string
};
CenterStackedVTwoBody.defaultProps = {
  pagesClassName: 'footer-pages'
};
var _default = CenterStackedVTwoBody;
exports["default"] = _default;